import { render } from "./DealerWorkingHours.vue?vue&type=template&id=df4921e8"
import script from "./DealerWorkingHours.vue?vue&type=script&lang=js"
export * from "./DealerWorkingHours.vue?vue&type=script&lang=js"

import "./DealerWorkingHours.vue?vue&type=style&index=0&id=df4921e8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/DealerWorkingHours/DealerWorkingHours.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df4921e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df4921e8', __exports__)) {
    api.reload('df4921e8', __exports__)
  }
  
  module.hot.accept("./DealerWorkingHours.vue?vue&type=template&id=df4921e8", () => {
    api.rerender('df4921e8', render)
  })

}


export default __exports__